import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from 'fuse-ui/components/Button';
import Modal from '../modal/modal';
import SendersList from './senders-list';

const styles = theme => ( {
    button: {
        margin: theme.spacing.unit,
    },
} );

const VerificationBySenderModal = ( {
    classes, domain, editMode, open, onClose, onSave, onSelection, saveDisabled, senders } ) => {
    const actions = (
    <>
        <Button
            onClick={onClose}
            variant="text"
            className={classes.button}
            data-automation-id="recognized-senders-modal-cancel-btn"
        >
            Cancel
        </Button>
        <Button
            onClick={onSave}
            color="primary"
            className={classes.button}
            data-automation-id="recognized-senders-modal-save-btn"
            disabled={saveDisabled}
        >
            Save
        </Button>
    </>
    );
    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Edit Senders"
            dialogContentText={`The following senders have been sending messages on behalf of ${domain}. The status of a sender determines how we process data in EFD.`}
            subTitle={domain}
            modalActions={actions}
            dataAutomationId="edit-recognized-senders-modal"
        >
            <SendersList sendersData={senders} editMode={editMode} onSelection={onSelection}/>
        </Modal>
    );

};

VerificationBySenderModal.propTypes = {
    classes: PropTypes.object.isRequired,
    domain: PropTypes.string.isRequired,
    editMode: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    onSelection: PropTypes.func,
    open: PropTypes.bool.isRequired,
    saveDisabled: PropTypes.bool,
    senders: PropTypes.array.isRequired,
};

VerificationBySenderModal.defaultProps = {
    saveDisabled: false
};

export default withStyles( styles )( VerificationBySenderModal );
